import { isEmpty } from "lodash";
import type { Audience } from "../../generated/WorkflowsApi.types";
import { removeEmptyValues } from "../AudienceMatchCounter/removeEmptyValues";

export const getAudienceHasValue = (audience: Audience = {}) => {
  const { rules = {} } = audience;
  const filters = removeEmptyValues(rules);
  return !isEmpty({ filters });
};
